import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Text } from '@reservamos/elements';
import CdsPointsPricingRow from './CdsPointsPricingRow';

/** Read only a completed owner's finalized, visible earning amount. */
function selectEarnedAmount({ purchase, whitelabelConfig, reserhubAccount }) {
  const earning = purchase.get('cdsPointsEarning');
  const points = earning?.get?.('points') ?? earning?.points;
  const status = earning?.get?.('status') ?? earning?.status;
  const eligible = earning?.get?.('eligible') ?? earning?.eligible;
  const user = reserhubAccount?.get('user');
  return whitelabelConfig.env.brand === 'cds' &&
    whitelabelConfig.features.CDS_POINTS_EARNING_ENABLED === true &&
    purchase.get('state') === 'completed' &&
    purchase.get('usesCdsPoints') !== true &&
    purchase.get('accountId') != null &&
    user?.id != null &&
    Boolean(user.sessionToken) &&
    String(purchase.get('accountId')) === String(user.id) &&
    status === 'finalized_estimate' &&
    eligible === true &&
    typeof points === 'string' &&
    /^\d+(?:\.\d+)?$/.test(points) &&
    Number.isFinite(Number(points)) &&
    Number(points) > 0
    ? points
    : null;
}

/** Historical cash rows are informational; the API payment total remains authoritative. */
export default function CdsPointsPricingDetails({ consumedPoints, hasAdditionalServices }) {
  const earnedAmount = useSelector(selectEarnedAmount);
  const { t } = useTranslation('purchase');
  if (consumedPoints == null && earnedAmount == null) return null;
  return (
    <div className="flex flex-col gap-3 py-2">
      {!hasAdditionalServices && <Text weight="bold">{t('label.additional')}</Text>}
      {consumedPoints != null && <CdsPointsPricingRow amount={consumedPoints} redeemed />}
      {earnedAmount != null && <CdsPointsPricingRow amount={earnedAmount} earned />}
    </div>
  );
}

CdsPointsPricingDetails.propTypes = {
  consumedPoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasAdditionalServices: PropTypes.bool.isRequired,
};
CdsPointsPricingDetails.defaultProps = { consumedPoints: null };
